var render, staticRenderFns
import script from "./tabbed-view.vue?vue&type=script&lang=js&"
export * from "./tabbed-view.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-view.vue?vue&type=style&index=0&id=129f5cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f5cba",
  null
  
)

export default component.exports